import { memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCircleExclamation } from '@fortawesome/free-solid-svg-icons/faFileCircleExclamation';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons/faCircleQuestion';
import { format, parseISO } from 'date-fns';
import { getDayFromDate } from '@translations/functions';
import { OrderStatistics } from '@api/shipping-data/types/OrderStatistics';
import BeerIcon from 'components/custom-icon/BeerIcon';
import FreeBeerIcon from 'components/custom-icon/FreeBeerIcon';
import CollectionIcon from 'components/custom-icon/CollectionIcon';
import MerchIcon from 'components/custom-icon/MerchIcon';
import TankIcon from 'components/custom-icon/TankIcon';
import CratesIcon from 'components/custom-icon/CratesIcon';
import { OrderStatus } from '@pages/orders/detail/tabs-pages/basic-overview/OrderStatus';



interface OrderRowProps {
	orderStatistics: OrderStatistics,
	isSelectedOrder: boolean,
	scrollToOrderGrid: (orderUnvId: string) => void,
}


const OrderRow = (props: OrderRowProps) => {
	const { orderStatistics, isSelectedOrder, scrollToOrderGrid } = props;
	const { clientId, unversionedSystemId, containsBeer, containsTank, containsFreeBeer, containsCollection, containsEmpties, containsPosm, containsClaim, containsUnknown,
		orderOriginalRequiredDeliveryDate, orderRequiredDeliveryDate, orderFirstVersionCreatedDate, shipmentPalletesCount
	} = props.orderStatistics;

	const containsNothing = !containsBeer && !containsTank && !containsFreeBeer && !containsCollection && !containsEmpties && !containsPosm && !containsClaim && !containsUnknown;

	const parsedCreatedDate = orderFirstVersionCreatedDate ? parseISO(orderFirstVersionCreatedDate) : null;
	const parsedCreatedDay = parsedCreatedDate ? getDayFromDate(parsedCreatedDate).toUpperCase() : null;
	const parsedCreatedResult = parsedCreatedDate && parsedCreatedDay ? `${parsedCreatedDay} ${format(parsedCreatedDate, 'd.M.')}` : '-';

	const parsedDeliveryDate = orderRequiredDeliveryDate ? parseISO(orderRequiredDeliveryDate) : null;
	const parsedDeliveryDay = parsedDeliveryDate ? getDayFromDate(parsedDeliveryDate).toUpperCase() : null;
	const parsedDeliveryResult = parsedDeliveryDate && parsedDeliveryDay ? `${parsedDeliveryDay} ${format(parsedDeliveryDate, 'd.M.')}` : '-';

	const parsedOriginalDate = orderOriginalRequiredDeliveryDate ? parseISO(orderOriginalRequiredDeliveryDate) : null;
	const parsedOriginalDay = parsedOriginalDate ? getDayFromDate(parsedOriginalDate).toUpperCase() : null;
	const parsedOriginalResult = parsedOriginalDate && parsedOriginalDay ? `${parsedOriginalDay} ${format(parsedOriginalDate, 'd.M.')}` : '-';

	return (
		<div className={`detail-order-item${isSelectedOrder ? ' selected-order-item' : ''}`}>

			<div className='order-info'>
				{containsBeer && <BeerIcon />}
				{containsTank && <TankIcon />}
				{containsFreeBeer && <FreeBeerIcon />}
				{containsCollection && <CollectionIcon />}
				{containsEmpties && <CratesIcon />}
				{containsPosm && <MerchIcon />}
				{containsClaim && <FontAwesomeIcon icon={faFileCircleExclamation} />}
				{containsUnknown && <FontAwesomeIcon icon={faCircleQuestion} />}

				{containsNothing && <FontAwesomeIcon icon={faCircleQuestion} />}

				<p className='item-label' onClick={() => scrollToOrderGrid(unversionedSystemId)}>
					{`${clientId} (založeno ${parsedCreatedResult}, závoz ${parsedDeliveryResult}${
						parsedDeliveryResult !== parsedOriginalResult ? `, předatováno z ${parsedOriginalResult}` : ''
					}${
						shipmentPalletesCount && shipmentPalletesCount > 0 ? `, počet palet ${shipmentPalletesCount}` : ''
					})`}
				</p>
			</div>

			<OrderStatus orderStatistics={orderStatistics} />

		</div>
	)
}

export default memo(OrderRow);